import { render, staticRenderFns } from "./ModernTribunalSelect.vue?vue&type=template&id=752bc19a"
import script from "./ModernTribunalSelect.vue?vue&type=script&lang=js"
export * from "./ModernTribunalSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports